import { useHandlers } from '../../../context/page-context';
import type { ShippingMethodsApiContract } from '../api';

export function useShippingMethodsApi(): { shippingMethodsApi: ShippingMethodsApiContract } {
  const { apis } = useHandlers();
  return { shippingMethodsApi: apis.shippingMethods };
}
